import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/',
		redirect: {
			path: '/message-threads',
		},
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/pages/LoginPage/LoginPage.vue'),
	},
	{
		path: '/complete',
		name: 'complete-message',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/PublicMessage/PublicMessage.vue'),
	},
	{
		path: '/screen-out',
		name: 'screen-out-message',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/PublicMessage/PublicMessage.vue'),
	},
	{
		path: '/quota-full',
		name: 'quota-full-message',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/PublicMessage/PublicMessage.vue'),
	},
	{
		path: '/thank-you',
		name: 'thank-you-message',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/PublicMessage/PublicMessage.vue'),
	},
	{
		path: '/already-completed',
		name: 'already-completed-message',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/PublicMessage/PublicMessage.vue'),
	},
	{
		path: '/link-invalid',
		name: 'link-invalid-message',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/PublicMessage/PublicMessage.vue'),
	},
	{
		path: '/quota/:token',
		name: 'quota-monitor',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/QuotaMonitorPage/QuotaMonitorPage.vue'),
	},
	{
		path: '/password-reset',
		name: 'password-reset',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/PasswordReset/PasswordReset.vue'),
	},
	{
		path: '/activation/:token',
		name: 'password-activate',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/ActivateUserPage/ActivateUserPage.vue'),
	},
	{
		path: '/password-reset/:token',
		name: 'password-reset-confirm',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/PasswordReset/PasswordReset.vue'),
	},
	{
		path: '/signup',
		name: 'signup',
		meta: {
			role: 'public',
		},
		component: () => import('@/pages/SignUpPage/SignUpPage.vue'),
	},
	{
		path: '/message-threads',
		name: 'message-threads',
		component: () => import('@/pages/MessageThreadPage/MessageThreadPage.vue'),
	},
	{
		path: '/users',
		name: 'users',
		component: () => import('@/pages/UsersPage/UsersPage.vue'),
	},
	{
		path: '/user-groups',
		name: 'user-groups',
		component: () => import('@/pages/UserGroupsPage/UserGroupsPage.vue'),
	},
	{
		path: '/invite-codes',
		name: 'invite-codes',
		component: () => import('@/pages/InviteCodePage/InviteCodePage.vue'),
	},
	{
		path: '/coupons',
		name: 'coupons',
		component: () => import('@/pages/CouponPage/CouponPage.vue'),
	},
	{
		path: '/profile',
		name: 'profile',
		component: () => import('@/pages/ProfilePage/ProfilePage.vue'),
	},
	{
		path: '/contact',
		name: 'contact',
		meta: {
			role: 'contact',
		},
		children: [
			{
				path: '/contact/survey',
				name: 'contact-survey',
				component: () => import('@/pages/ContactSurveyPage/ContactSurveyPage.vue'),
			},
			{
				path: '/contact/survey/filled/:id',
				name: 'contact-survey-filled',
				component: () => import('@/pages/ContactFilledSurveyPage/ContactFilledSurveyPage.vue'),
			},
			{
				path: '/contact/users',
				name: 'contact-users',
				component: () => import('@/pages/ContactUsersPage/ContactUsersPage.vue'),
			},
		],
	},
	{
		path: '/user',
		name: 'user',
		meta: {
			role: 'user',
		},
		children: [
			{
				path: '/user/surveys',
				name: 'user-surveys',
				component: () => import('@/pages/UserSurveyPage/UserSurveyPage.vue'),
			},
			{
				path: '/user/survey/fill/:id',
				name: 'user-survey-fill',
				meta: {
					role: 'user',
				},
				component: () => import('@/pages/UserSurveyFillPage/UserSurveyFillPage.vue'),
			},
			{
				path: '/user/survey/show/:id',
				name: 'user-survey-show',
				component: () => import('@/pages/UserSurveyShowPage/UserSurveyShowPage.vue'),
			},
			{
				path: '/user/my-coupons',
				name: 'user-my-coupons',
				component: () => import('@/pages/UserCouponsPage/UserCouponsPage.vue'),
			},
		],
	},
	{
		path: '/survey',
		name: 'survey',
		meta: {
			role: 'admin',
		},
		children: [
			{
				path: '/survey/list',
				name: 'survey-list',
				component: () => import('@/pages/SurveyListPage/SurveyListPage.vue'),
			},
			{
				path: '/survey/public/:id/:slug',
				name: 'survey-public',
				meta: {
					role: 'public',
				},
				component: () => import('@/pages/SurveyFillPage/SurveyFillPage.vue'),
			},
			{
				path: '/survey/edit/:id/',
				name: 'survey-edit',
				component: () => import('@/pages/SurveyEditPage/SurveyEditPage.vue'),
			},
			{
				path: '/survey/statistics/:id',
				name: 'survey-statistics',
				component: () => import('@/pages/SurveyStatisticsPage/SurveyStatisticsPage.vue'),
			},
			{
				path: '/survey/filled/list/:id',
				name: 'survey-filled-list',
				component: () => import('@/pages/SurveyFilledListPage/SurveyFilledListPage.vue'),
			},
		],
	},
	{
		path: '/rolunk',
		component: () => import('@/pages/AboutPage/AboutPage.vue'),
	},
	// {
	// 	path: '/:pathMatch(.*)*',
	// 	alias: '/404',
	// 	component: () => import('@/pages/NotFound/NotFoundPage.vue'),
	// },
];

export default routes;
